import { c as _c } from "react/compiler-runtime";
import { Sheet, SheetContent, SheetHeader, SheetOverlay } from "@/components/rac/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";
function SlotSheetOverLay(t0) {
  const $ = _c(19);
  const {
    isOpen,
    children,
    onClose,
    header
  } = t0;
  const isMobile = useIsMobile();
  const [internalOpen, setInternalOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== internalOpen || $[1] !== isOpen) {
    t1 = () => {
      if (isOpen !== internalOpen) {
        setInternalOpen(isOpen);
      }
    };
    t2 = [isOpen, internalOpen];
    $[0] = internalOpen;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const sheetOverlayClass = `w-full  max-w-full w-[500px] px-0 ${isMobile ? "rounded-2xl max-h-[90dvh]" : ""}`;
  let t3;
  if ($[4] !== onClose) {
    t3 = open => {
      if (!open) {
        onClose();
      }
    };
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      zIndex: 100000000
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== header) {
    t5 = header && <h2 className="text-xl font-semibold text-gray-900">{header}</h2>;
    $[7] = header;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <SheetHeader>{t5}</SheetHeader>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== sheetOverlayClass || $[13] !== t6) {
    t7 = <SheetOverlay style={t4}><SheetContent side="bottom" className={sheetOverlayClass}>{t6}{children}</SheetContent></SheetOverlay>;
    $[11] = children;
    $[12] = sheetOverlayClass;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== internalOpen || $[16] !== t3 || $[17] !== t7) {
    t8 = <Sheet isOpen={internalOpen} onOpenChange={t3}>{t7}</Sheet>;
    $[15] = internalOpen;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default SlotSheetOverLay;